"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PreviewCard_exports = {};
__export(PreviewCard_exports, {
  default: () => PreviewCard_default
});
module.exports = __toCommonJS(PreviewCard_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.16797 14.4102C5.16797 14.7357 5.27865 15.0156 5.5 15.25C5.73438 15.4714 6.01432 15.582 6.33984 15.582H14.7578C15.0833 15.582 15.3568 15.4714 15.5781 15.25C15.8125 15.0156 15.9297 14.7357 15.9297 14.4102V10.8945C15.9297 10.7513 15.9753 10.6341 16.0664 10.543C16.1706 10.4388 16.2943 10.3867 16.4375 10.3867C16.5677 10.3867 16.6784 10.4388 16.7695 10.543C16.8737 10.6341 16.9258 10.7513 16.9258 10.8945V14.4102C16.9258 15.0091 16.7109 15.5234 16.2812 15.9531C15.8646 16.3698 15.3568 16.5781 14.7578 16.5781H6.33984C5.74089 16.5781 5.22656 16.3698 4.79688 15.9531C4.38021 15.5234 4.17188 15.0091 4.17188 14.4102V5.99219C4.17188 5.39323 4.38021 4.88542 4.79688 4.46875C5.22656 4.03906 5.74089 3.82422 6.33984 3.82422H9.81641C9.94661 3.82422 10.0573 3.8763 10.1484 3.98047C10.2526 4.07161 10.3047 4.18229 10.3047 4.3125C10.3047 4.45573 10.2526 4.57943 10.1484 4.68359C10.0573 4.77474 9.94661 4.82031 9.81641 4.82031H6.33984C6.01432 4.82031 5.73438 4.9375 5.5 5.17188C5.27865 5.39323 5.16797 5.66667 5.16797 5.99219V14.4102ZM17.5117 3.23828C17.5768 3.29036 17.6159 3.34896 17.6289 3.41406C17.6549 3.47917 17.668 3.55078 17.668 3.62891C17.668 3.62891 17.668 3.63542 17.668 3.64844C17.668 3.64844 17.668 3.65495 17.668 3.66797V8.02344C17.668 8.16667 17.6159 8.29036 17.5117 8.39453C17.4206 8.48568 17.3034 8.53125 17.1602 8.53125C17.0299 8.53125 16.9128 8.48568 16.8086 8.39453C16.7174 8.29036 16.6719 8.16667 16.6719 8.02344V4.78125L10.168 11.2852C10.0638 11.3893 9.9401 11.4414 9.79688 11.4414C9.66667 11.4414 9.55599 11.3893 9.46484 11.2852C9.36068 11.194 9.30859 11.0833 9.30859 10.9531C9.30859 10.8099 9.36068 10.6862 9.46484 10.582L15.9688 4.07812H12.7461C12.6159 4.07812 12.4987 4.03255 12.3945 3.94141C12.3034 3.83724 12.2578 3.72005 12.2578 3.58984C12.2578 3.44661 12.3034 3.32943 12.3945 3.23828C12.4987 3.13411 12.6159 3.08203 12.7461 3.08203H17.082C17.0951 3.08203 17.1016 3.08203 17.1016 3.08203C17.1146 3.08203 17.1211 3.08203 17.1211 3.08203C17.1992 3.08203 17.2708 3.09505 17.3359 3.12109C17.401 3.13411 17.4596 3.17318 17.5117 3.23828Z",
      fill: "currentColor"
    }
  )
);
const SvgPreviewCard = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var PreviewCard_default = SvgPreviewCard;
